import { environment } from "../environment/environment";
import { StaticConfig } from "../models/IStaticConfig";

export const isForceUpdateRequired = async (fetchedConfig: StaticConfig): Promise<boolean> => {
  return (
    (window as any).electronAPI &&
    fetchedConfig.windowsClientVersion > environment.huddleClientVersion
  );
};
